import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CreatorData,
  CreatorsState,
  CreatorContactInfo,
  CreatorByIdData,
  ReasonForHideType,
  ManageCreatorData,
  CreatorInteractionsData,
} from "../types/creatorsTypes.tsx";
import {
  fetchCreatorsData,
  fetchCreatorContactsById,
  fetchCreatorById,
  fetchManageCreatorsList,
  interactionsCreator,
  fetchReasonsForHide,
  deleteStatusCreator,
} from "../thunks/creatorsThunk.tsx";
import { CreatorBrief } from "../types/creatorBriefsTypes.tsx";

const initialState: CreatorsState = {
  isLoading: false,
  isLoadingById: false,
  isLoadingReasons: false,
  creators: null,
  manageCreators: null,
  creatorById: null,
  selectedCreator: null,
  selectedCreatorContacts: null,
  error: null,
  reasonsForHide: null,
};

export const creatorsSlice = createSlice({
  name: "creators",
  initialState,
  reducers: {
    resetSelectedCreatorContacts: (state) => {
      state.selectedCreatorContacts = null;
    },
    setBriefForCreator: (state, action: PayloadAction<CreatorBrief>) => {
      const brief = action.payload;
      if (state.manageCreators) {
        const manageCreatorBrief = {
          id: brief.id,
          is_ai_generated: brief.is_ai_generated,
          title: brief.title,
        };
        state.manageCreators = state.manageCreators.map((creator) =>
          creator.id === brief.creator.id
            ? {
                ...creator,
                creator_briefs:
                  creator.creator_briefs.length > 0
                    ? [...creator.creator_briefs, manageCreatorBrief]
                    : [manageCreatorBrief],
              }
            : creator,
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCreatorsData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchCreatorsData.fulfilled,
      (state, action: PayloadAction<CreatorData[]>) => {
        state.isLoading = false;
        state.creators = action.payload;
      },
    );
    builder.addCase(fetchCreatorsData.rejected, (state, action) => {
      state.isLoading = false;
      state.error =
        (action.payload as string) ||
        action.error.message ||
        "An unknown error occurred";
    });
    builder.addCase(fetchManageCreatorsList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchManageCreatorsList.fulfilled,
      (state, action: PayloadAction<ManageCreatorData[]>) => {
        state.isLoading = false;
        state.manageCreators = action.payload;
      },
    );
    builder.addCase(fetchManageCreatorsList.rejected, (state, action) => {
      state.isLoading = false;
      state.error =
        (action.payload as string) ||
        action.error.message ||
        "An unknown error occurred";
    });
    builder.addCase(fetchCreatorById.pending, (state) => {
      state.isLoadingById = true;
    });
    builder.addCase(
      fetchCreatorById.fulfilled,
      (state, action: PayloadAction<CreatorByIdData>) => {
        state.isLoadingById = false;
        state.creatorById = action.payload;
      },
    );
    builder.addCase(fetchCreatorById.rejected, (state, action) => {
      state.isLoadingById = false;
      state.error =
        (action.payload as string) ||
        action.error.message ||
        "An unknown error occurred";
    });
    builder.addCase(
      fetchReasonsForHide.fulfilled,
      (state, action: PayloadAction<ReasonForHideType[]>) => {
        state.reasonsForHide = action.payload;
      },
    );
    builder.addCase(
      fetchCreatorContactsById.fulfilled,
      (state, action: PayloadAction<CreatorContactInfo>) => {
        state.selectedCreatorContacts = action.payload;
        state.selectedCreatorContacts = action.payload;
      },
    );
    builder.addCase(fetchCreatorContactsById.rejected, (state, action) => {
      state.error =
        (action.payload as string) ||
        action.error.message ||
        "An unknown error occured";
    });
    builder.addCase(interactionsCreator.pending, (state) => {
      state.isLoadingReasons = true;
    });
    builder.addCase(
      interactionsCreator.fulfilled,
      (state, action: PayloadAction<CreatorInteractionsData>) => {
        state.isLoadingReasons = false;
        if (state.manageCreators) {
          state.manageCreators = state.manageCreators.map((item) =>
            item.id === action.payload.id
              ? { ...item, user_interaction_status: action.payload.body.status }
              : item,
          );
        }
      },
    );
    builder.addCase(interactionsCreator.rejected, (state) => {
      state.isLoadingReasons = false;
    });

    builder.addCase(
      deleteStatusCreator.fulfilled,
      (state, action: PayloadAction<number>) => {
        if (state.manageCreators) {
          state.manageCreators = state.manageCreators.filter(
            (item) => item.id !== action.payload,
          );
        }
      },
    );
  },
});

export const { resetSelectedCreatorContacts, setBriefForCreator } =
  creatorsSlice.actions;
export default creatorsSlice.reducer;
